class LoginDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#LoginDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.querySelector('#recoverPasswordButton').addEventListener('click', this.showResetPassword.bind(this));
    this.querySelector('#loginButton').addEventListener('click', this.hideResetPassword.bind(this));
    this.querySelector('#createAccountButton').addEventListener('click', this.toggleRegister.bind(this));
    new URL(window.location.href).searchParams.get("loginDrawer") && this.open()
  }

  setHeaderCartIconAccessibility() {
    const loginLink = document.querySelector('#login-drawer-bubble');
    loginLink.setAttribute('role', 'button');
    loginLink.setAttribute('aria-haspopup', 'dialog');
    loginLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(loginLink)
    });
    loginLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(loginLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = document.getElementById('LoginDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.login__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
    document.body.classList.add('login-open');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('login-open');
  }

  toggleRegister(){
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('login-open');

    document.querySelector('#register-drawer-bubble').click();
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  showResetPassword(){
    this.querySelectorAll('[account-login]').forEach(login => {
      login.classList.add('hidden')
    });
    this.querySelectorAll('[account-reset-password]').forEach(reset => {
      reset.classList.remove('hidden')
    });
  }

  hideResetPassword(){
    this.querySelectorAll('[account-login]').forEach(login => {
      login.classList.remove('hidden')
    });
    this.querySelectorAll('[account-reset-password]').forEach(reset => {
      reset.classList.add('hidden')
    });
  }
}

customElements.define('login-drawer', LoginDrawer);